import React, {useState} from "react";
import styles from "./addNewLayer/AddNewLayer.module.scss";
import Button from "../../../../Componnets/Button/Button";
import SelectBox from "../../../../Componnets/SelectBox/SelectBox";

const AddNewLayer = ({ showNewLayerPopup, onClick, handleAddNewLayer, handleShowNewLayerPopup, analysisData, sidebarData }) => {

    const [selectedOption, setSelectedOption] = useState(null);

    const sidebarDataIds = sidebarData.map(item => item.layer);

    const handleOnClick = (option) => {
        setSelectedOption(option)
    }

    const handleSubmit = () => {
        setSelectedOption(null);
        if (selectedOption) {
            handleAddNewLayer(selectedOption);
            handleShowNewLayerPopup();
        }
    }

    return (
        <div className={`addNewLayer ${styles.addNewLayerWrapper}`}>
            <div onClick={onClick} className={`d-flex align-items-center justify-content-between ${styles.addNewLayer} ${showNewLayerPopup ? styles.active : ''}`}>
                <div className={'d-flex'}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.99997 6.93942V13.0447" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.0555 9.99207H6.94443" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9048 1.66667H6.09523C3.37301 1.66667 1.66666 3.59341 1.66666 6.32097V13.679C1.66666 16.4066 3.36507 18.3333 6.09523 18.3333H13.9048C16.6349 18.3333 18.3333 16.4066 18.3333 13.679V6.32097C18.3333 3.59341 16.6349 1.66667 13.9048 1.66667Z" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div className={styles.text}>
                    Add New layer
                </div>
            </div>
            {
                showNewLayerPopup &&
                <div onClick={(e) => e.stopPropagation()} className={styles.newLayerPopup}>
                    <div className={'d-flex align-items-center justify-content-between'}>
                        <div className={styles.title}>
                            Add New layer
                        </div>
                        <div onClick={handleShowNewLayerPopup} className={`d-flex ${styles.closeBtn}`}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <line x1="14.25" y1="4.81066" x2="4.81066" y2="14.25" stroke="#70789E" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M4.44995 4.45L14.2075 14.2075" stroke="#70789E" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>
                        </div>
                    </div>
                    <div>
                        <p className={'mb-3'}>
                            You can select an Analysis to compare with the <span>current process map you have on this analysis.</span>
                            <br/>
                            You can compare processes sharing the same data connector.
                        </p>
                        <SelectBox
                            dropDownValue={selectedOption ? selectedOption.name : 'Choose an Option'}
                        >
                            {
                                analysisData.length > 0 && analysisData.map(option => (
                                    <div
                                        onClick={() => handleOnClick(option)}
                                        className={sidebarDataIds.includes(option.id) && styles.disabled}
                                    >
                                        {option.name}
                                    </div>
                                ))
                            }
                        </SelectBox>
                    </div>
                    <div className={'mt-4'}>
                        <Button
                            title={'Add'}
                            type={'primary'}
                            size={'block'}
                            height={'medium'}
                            onClick={handleSubmit}
                        />
                    </div>
                </div>
            }
        </div>
    )
}

export default AddNewLayer;